import svg4everybody from 'svg4everybody';
import $ from 'jquery';
import 'slick-carousel';
//import 'social-likes';
//import 'ion-rangeslider';
import Cookies from 'js-cookie';
import 'jquery-colorbox';
import 'jquery.scrollto';
import 'jquery-form';


$(() => {
	svg4everybody();

	$.extend($.colorbox.settings, {
		current: "{current} / {total}",
		previous: "&#10229;",
		next: "&#10230;",
		close: "&#10005;",
		xhrError: "Не удалось загрузить содержимое.",
		imgError: "Не удалось загрузить изображение.",
		slideshowStart: "начать слайд-шоу",
		slideshowStop: "остановить слайд-шоу",
		opacity: 0.2
	});
});

(function (pType) {
	$(function () {

		const $window = $(window);

		if (typeof window.langEn === 'undefined') {
			window.langEn = false;
		}

		window.sys = {};

		window.sys.checkIsDesktop = function () {
			return $window.width() > 1160;
		};
		window.sys.checkIsTablet = function () {
			return $window.width() > 800 && $window.width() <= 1160;
		};
		window.sys.checkIsMobile = function () {
			return $window.width() <= 800;
		};

		let token = '';
		$.post('/mail.php', {action : 'getToken'}, function(a, b, c) {
			token = a;
		});

		const $modals = $('.modal');
		const $modalsBackdrop = $modals.find('.modal_backdrop');

		$modals.find('._modal_close').click(function () {
			$(this).closest('.modal_container').fadeOut(500, function () {
				$modalsBackdrop.hide();
				$modals.hide();

				$('body').removeClass('modal_open_body');
			});

			return false;
		});

		const showModalInfo = function (header, message) {
			if ( !$modals.length) {
				return;
			}

			const $modalInfo = $modals.find('.modal__info');
			$modalInfo.find('.modal_header h1').text(header);
			$modalInfo.find('.modal_message').text(message);

			$modals.show();
			$modalsBackdrop.show();
			$modalInfo.show();
		};


		const showModalCallback = function (header, subheader, btn, subject) {
			if ( !$modals.length) {
				return;
			}

			const $modalCallback = $modals.find('.modal__callback');
			$modalCallback.find('.form_data .form_header').text(header);
			$modalCallback.find('.form_data .form_subheader').text(subheader);
			$modalCallback.find('.form_data .btn').text(btn);
			$modalCallback.find('.form_data input[name="email_subject"]').val(subject);

			$('body').addClass('modal_open_body');

			$modals.show();
			$modalsBackdrop.show();
			$modalCallback.fadeIn(500);
		};

		const showModal = function (modalClass) {
			if ( !$modals.length) {
				return;
			}

			const $modalPopup = $modals.find('.' + modalClass);

			$('body').addClass('modal_open_body');

			$modals.show();
			$modalsBackdrop.show();
			$modals.find('.modal_container').hide();
			$modalPopup.fadeIn(500);
		};


		$('.handler-open-callback-popup').click(function () {
			showModalCallback(
				$(this).data('header'),
				$(this).data('subheader'),
				$(this).data('btn'),
				$(this).data('subject')
			);
			return false;
		});

		$('.handler-open-modal').click(function () {
			const $this = $(this);
			if ($this.attr('rel')) {
				showModal($this.attr('rel'));
			}
			return false;
		});

		// AJAX FORMS
		(function () {
			$('._ajax_form').each(function (index, form) {
				const $form = $(form);

				$form.find('.form_input.input_text').each(function (index, input) {
					const $input = $(input);

					$input.find('input[type=text], input[type=number], input[type=password], textarea').focus(function () {
						$input.removeClass('error');
					});
				});

				$form.find('.form_input.input_checkbox').each(function (index, input) {
					const $input = $(input);

					$input.find('label').click(function () {
						$input.removeClass('error').toggleClass('checked');
					});
				});

				$form.find('.handler-send-form').click(function () {
					const $this = $(this);
					if ($this.hasClass('_waiting')) {
						return false;
					}

					let error = false;
					$form.find('.form_input.required:visible').each(function (index, input) {
						const $input = $(input);

						if ($input.hasClass('input_text')) {
							let value = '';
							if ($input.find('input').length) {
								value = $input.find('input').val();
							} else if ($input.find('textarea').length) {
								value = $input.find('textarea').val();
							}
							if ( !value.trim().length) {
								error = true;
								$input.addClass('error');
							}
						} else if ($input.hasClass('input_checkbox')) {
							if ( !$input.hasClass('checked')) {
								error = true;
								$input.addClass('error');
							}
						}
					});

					if (error) {
						return false;
					}

					$this.addClass('_waiting');
					$this.data('initial-text', $this.text()).text('Подождите...');

					if ($form.hasClass('_ajax_form_classic')) {
						$form.get(0).submit();
					} else {
						let data = {token};
						$form.find('input, textarea, select').each(function (index, input) {
							const $input = $(input);
							if ($input.prop('name')) {
								data[$input.prop('name')] = $input.val();
							}
						});

						$.post($form.data('fa'), data, function (result, b, c) {
							if ($form.hasClass('_show_result_popup')) {
								$form.find('input, textarea, select').val('');
								showModal('modal__result');
							} else {
								$form.find('.form_data').hide();
								$form.find('.form_result').show();
								// $this.closest('.modal_container').addClass('form-send');
							}

							$this.removeClass('_waiting');
							$this.text($this.data('initial-text'));
						});
					}

					return false;
				});
			});
		})();

		// MANUFACTURERS CAROUSEL
		(function () {
			if ( !$('.manufacturers .manufacturers_slider_list').length) {
				return;
			}

			const $manufacturersSlider = $('.manufacturers_slider .manufacturers_slider_list');
			function createManufacturersSlider() {
				if (window.sys.checkIsMobile() || $manufacturersSlider.find('.manufacturers_slider_item').length > 6) {
					$manufacturersSlider.slick({
						slidesToShow: window.sys.checkIsMobile() ? 3 : 6,
						centerMode: false,
						variableWidth: false,
						infinite: true,

						autoplay: true,
						autoplaySpeed: 3000,

						dots: false,
						arrows: window.sys.checkIsMobile(),

						speed: 900,
						swipe: true,
						swipeToSlide: true,

						appendArrows: $('.manufacturers_slider .manufacturers_slider_controls'),
					});
				}
			};

			$.get('/imagelist.php', {
				folder: $manufacturersSlider.data('image-folder')
			}, function (result) {
				if (result && result.length) {
					for (let i = 0; i < result.length; i++) {
						$('<div>').addClass('manufacturers_slider_item').append(
							$('<div>').addClass('manufacturers_slider_item_inner').append(
								$('<img>').attr({
									'src' : result[i].src
								})
							)
						).appendTo($manufacturersSlider);
					}
					createManufacturersSlider();
				}
			}, 'json');
		})();

		// PROMO CAROUSEL
		(function () {
			if ( !$('.promotion_slider .promotion_slider_list').length) {
				return;
			}

			const $promotionsSlider = $('.promotion_slider .promotion_slider_list');
			$promotionsSlider.slick({
				slidesToShow: 1,
				centerMode: false,
				variableWidth: false,
				infinite: true,

				dots: true,
				arrows: true,

				speed: 900,
				swipe: true,
				swipeToSlide: true,

				appendArrows: $('.promotion_slider .promotion_slider_controls'),
				appendDots: $('.promotion_slider .promotion_slider_dots')
			});
		})();

		// FEEDBACK CAROUSEL
		(function () {
			if ( !$('.feedback_slider .feedback_slider_list').length) {
				return;
			}

			const $feedbackSlider = $('.feedback_slider .feedback_slider_list');
			$feedbackSlider.slick({
				slidesToShow: 1,
				centerMode: false,
				variableWidth: false,
				adaptiveHeight: true,
				infinite: true,

				dots: true,
				arrows: true,

				speed: 900,
				swipe: true,
				swipeToSlide: true,

				appendArrows: $('.feedback_slider .feedback_slider_controls'),
				appendDots: $('.feedback_slider .feedback_slider_dots')
			});
		})();

		// QUESTIONS LIST
		(function () {
			if ( !$('.question_list').length) {
				return;
			}

			$('.question_list .question_item').click(function () {
				const $this = $(this);

				$this.toggleClass('open');
				$this.find('.question_item_answer').slideToggle();

				return false;
			});
		})();

		// CERTS CAROUSEL
		(function () {
			if ( !$('.history_certs_slider .history_certs_slider_list').length) {
				return;
			}

			const $certsSlider = $('.history_certs_slider .history_certs_slider_list');
			function createCertsSlider() {
				$certsSlider.slick({
					slidesToShow:  window.sys.checkIsMobile() ? 3 : 4,
					centerMode: false,
					variableWidth: false,
					adaptiveHeight: false,
					infinite: false,

					dots: false,
					arrows: true,

					speed: 900,
					swipe: true,
					swipeToSlide: true,

					appendArrows: $('.history_certs_slider .history_certs_slider_controls'),
				});

				$('._colorbox').colorbox({
					maxWidth: '80%',
					maxHeight: '80%'
				});
			}

			$.get('/imagelist.php', {
				folder: $certsSlider.data('image-folder')
			}, function (result) {
				if (result && result.length) {
					for (let i = 0; i < result.length; i++) {
						$('<div>').addClass('history_certs_slider_item').append(
							$('<a>').addClass('_colorbox').attr({href : result[i].src}).append(
								$('<img>').attr({
									src : result[i].src
								})
							)
						).appendTo($certsSlider);
					}
					createCertsSlider();
				}
			}, 'json');
		})();

		// STEPS CAROUSEL
		(function () {
			if ( !$('.steps_slider .steps_list').length) {
				return;
			}

			const $manufacturersSlider = $('.steps_slider .steps_list');
			if (window.sys.checkIsMobile()) {
				$manufacturersSlider.slick({
					slidesToShow: 1,
					centerMode: false,
					variableWidth: false,
					infinite: false,

					//autoplay: true,
					autoplaySpeed: 3000,

					dots: false,
					arrows: true,

					speed: 900,
					swipe: true,
					swipeToSlide: true,

					appendArrows: $('.steps_slider .steps_slider_controls')
				});
			}
		})();

		// PORTFOLIIO LOADING
		(function () {
			if ( !$('.portfolio .portfolio_fotorama').length) {
				return;
			}

			const $fotoramaContainer = $('.portfolio .portfolio_fotorama');
			let $fotorama;

			function createFotorama() {
				$fotorama.fotorama({
					width: '100%',
					ratio: 1180 / 600,
					nav: 'thumbs',
					allowfullscreen: true,
					click: false
				});
				$fotorama.find('.fotorama__stage__shaft').click(function () {
					$fotorama.data('fotorama').requestFullScreen();
					return false;
				});
			}

			$.get('/imagelist.php', {
				folder: $fotoramaContainer.data('image-folder')
			}, function (result) {
				if (result && result.length) {
					$fotorama = $('<div>').addClass('fotorama').data({}).appendTo($fotoramaContainer);

					for (let i = 0; i < result.length; i++) {
						$('<img>').attr({
							src: result[i].src
						}).appendTo($fotorama);
					}
					createFotorama();
				}
			}, 'json');
		})();

		$('header .header_menu a').click(function () {
			$.scrollTo($(this).attr('rel'), 1000);
			return false;
		});

		$('.info .info_column_readmore a').click(function () {
			$(this).closest('.info_column').find('.info_column_desc_more').slideToggle();
			return false;
		});

		/** *****************************************/
	});
})('DEBUG');



// WEBPACK FOOTER //
// ./app/scripts/app.js